import { type ClassValue, clsx } from 'clsx';
import type { Config } from 'tailwind-merge';
import { extendTailwindMerge } from 'tailwind-merge';

const TSHIRT_SIZES = ['sm', 'md', 'lg', 'xs'] as const;

export const DEFAULT_MERGE_CONFIG: Partial<Config<never, never>> = {
  theme: {
    spacing: [
      'px',
      '0',
      '2xs',
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
      '2xl',
      '3xl',
      '4xl',
    ],
    borderWidth: ['2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl'],
  },
  classGroups: {
    // This is to allow background gradients and images to work together. If not,
    // one of them will be removed from the final class list. For an example,
    // see the PlatformsTab that uses bg-gradient and bg-level-01/full together.
    'bg-image': ['bg-gradient'],
    'font-size': {
      // This could be done via tailwind config import, but there is a problem with module resolution and typing
      text: [
        ...TSHIRT_SIZES.map((size) => `display-${size}`),
        ...TSHIRT_SIZES.map((size) => `headline-${size}`),
        ...TSHIRT_SIZES.map((size) => `body-${size}`),
        ...TSHIRT_SIZES.map((size) => `caption-${size}`),
      ],
    },
    'max-h': [
      'max-h-radix-scroll',
      'max-h-dropdown-single-select-scroll',
      'max-h-dropdown-tree-single-select-scroll',
    ],
  },
};

const mergeClasses = extendTailwindMerge({
  extend: DEFAULT_MERGE_CONFIG,
});

export const cn = (...inputs: ClassValue[]) => mergeClasses(clsx(inputs));
